import { Card, CardContent, CardMedia, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { MarketingAnchor } from './MarketingMenu';
import { StyledTitleRow } from './StyledTitle';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        circle1: {
            borderRadius: '50%',
            border: '4px white solid',
            position: 'absolute',
            top: '70px',
            left: '0px',
        },
        circle2: {
            borderRadius: '50%',
            border: '4px white solid',
            position: 'absolute',
            top: '10px',
            left: '240px',
        },
    }),
);

export const Marketing03_inwestycja = () => {
    const classes = useStyles();

    return (
        <>
            <div className="bg-gradient-bee-diagonal">
                <MarketingAnchor id="inwestycja" />
                <Container>
                    <StyledTitleRow text="Inwestycja" white />
                    <Row className="mt-3">
                        <Col xs={{ span: 12, order: 2 }} lg={{ span: 7, order: 1 }} className="my-5">
                            <Typography variant="subtitle1" align="justify"
                                className="text-white-shadow"
                            >
                                Osiedle "Park Baczyńskiego" składa się z jedenastu domów jednorodzinnych w zabudowie bliźniaczej i szeregowej.
                                <br />
                                <br />
                                Przestronne wnętrza, prywatne ogrody, zadaszone tarasy i garaże tworzą wygodną i funkcjonalną przestrzeń dla komfortu codziennego życia. 
                                Nowoczesne elewacje oraz duże przeszklenia nadają całości elegancji i podkreślają współczesny charakter osiedla.
                                <br />
                                <br />
                                Bliskość natury i wygodne połączenie z miastem sprawiają, że to idealne miejsce zarówno dla rodzin jak i osób pracujących zdalnie.
                                <br />
                                <br />
                                Pierwsze domy są już dostępne. Zakończenie I etapu inwestycji zaplanowane jest na IV kwartał 2025 roku.
                                <br />
                            </Typography>
                        </Col>
                        <Col xs={{ span: 12, order: 1 }} lg={{ span: 5, order: 2 }} className=""
                            style={{
                                minHeight: '500px',
                            }}
                        >
                            <img src="./img/Wizki/Inwestycja_1.jpg" width="340" height="340" alt="wizka" className={classes.circle1} />
                            <img src="./img/Wizki/Inwestycja_2.jpg" width="200" height="200" alt="wizka" className={classes.circle2} />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col xs={{ span: 12, order: 2 }} lg={{ span: 3, order: 1 }} className="my-5">
                            <Card sx={{ maxWidth: 345, height: '100%', marginX: 'auto' }} elevation={12}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image="./img/Wizki/7_2025_09_29.png"
                                    alt="wizka"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        Kameralne Osiedle
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Wyjątkowe osiedle składające się z zaledwie 11 domów parterowych, położonych w ostatniej linii zabudowy – tuż przy terenach zielonych
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Col>
                        <Col xs={{ span: 12, order: 2 }} lg={{ span: 3, order: 1 }} className="my-5">
                            <Card sx={{ maxWidth: 345, height: '100%', marginX: 'auto' }} elevation={12}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image="./img/Wizki/dron_1.png"
                                    alt="wizka"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        Willowa Okolica
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Jedna z ostatnich okazji, by zamieszkać w prestiżowej willowej dzielnicy Oławy! Domy parterowe z ogrodami wśród zieleni dają poczucie luksusu i prywatności, na które zasługujesz.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Col>
                        <Col xs={{ span: 12, order: 2 }} lg={{ span: 3, order: 1 }} className="my-5">
                            <Card sx={{ maxWidth: 345, height: '100%', marginX: 'auto' }} elevation={12}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image="./img/Wizki/1_2025_09_29.png"
                                    alt="wizka"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        Ogrody
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Oaza spokoju i możliwości własnej aranżacji przydomowej zieleni przy każdym domu.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Col>
                        <Col xs={{ span: 12, order: 2 }} lg={{ span: 3, order: 1 }} className="my-5">
                            <Card sx={{ maxWidth: 345, height: '100%', marginX: 'auto' }} elevation={12}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image="./img/Wizki/przestrzen.jpg"
                                    alt="wizka"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        Przestrzeń
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Domy pełne naturalnego światła – 140m² przestrzeni zaprojektowanej z myślą o Tobie. Dodatkowo strych, balkon, zadaszony taras, ganek oraz własny ogród.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Col>
                    </Row>
                </Container >
            </div>
        </>
    );
};
